import { render } from "./update.vue?vue&type=template&id=1bffcb9f"
import script from "./update.vue?vue&type=script&lang=js"
export * from "./update.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__